module.exports = __webpack_public_path__ + "img/proxima_top_logo.e21d9a1e.svg";